export { default as useComposerDockHeight } from './useComposerDockHeight';
